import { render } from "./SnapSlider.vue?vue&type=template&id=9b35a8fc&scoped=true"
import script from "./SnapSlider.vue?vue&type=script&lang=js"
export * from "./SnapSlider.vue?vue&type=script&lang=js"

import "./SnapSlider.vue?vue&type=style&index=0&id=9b35a8fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b35a8fc"]])

export default __exports__